<div class="login-container">
	<h1 class="brand-title">ZaidSystems</h1>
	<mat-card appearance="raised" class="login-card">
		<div class="avatar-wrapper">
			<div class="avatar-circle" aria-hidden="true">
				<mat-icon fontIcon="directions_boat" class="avatar-icon"></mat-icon>
			</div>
		</div>
		<mat-card-header>
			<mat-card-title>Iniciar sesión</mat-card-title>
			<mat-card-subtitle>Accede con tu cuenta</mat-card-subtitle>
		</mat-card-header>
        <br>
		<mat-card-content>
			<form [formGroup]="form" (ngSubmit)="submit()" class="login-form" novalidate>
				<mat-form-field appearance="outline" class="full-width">
					<mat-label>Email</mat-label>
					<input matInput type="email" formControlName="email" placeholder="tu@correo.com" required>
					@if (email?.hasError('required')) { <mat-error>El email es obligatorio</mat-error> }
					@if (email?.hasError('email')) { <mat-error>Introduce un email válido</mat-error> }
				</mat-form-field>

				<mat-form-field appearance="outline" class="full-width">
					<mat-label>Contraseña</mat-label>
					<input matInput type="password" formControlName="password" placeholder="••••••••" required>
					@if (password?.hasError('required')) { <mat-error>La contraseña es obligatoria</mat-error> }
					@if (password?.hasError('minlength')) { <mat-error>Mínimo 6 caracteres</mat-error> }
				</mat-form-field>

				<div class="actions">
					<a class="forgot-link" (click)="gotoForgotPassword()">
						¿Olvidaste tu contraseña?
					</a>
					<button mat-flat-button color="primary" type="submit" [disabled]="form.invalid || submitting()">
						{{ submitting() ? 'Iniciando...' : 'Iniciar sesión' }}
					</button>
				</div>
			</form>
		</mat-card-content>
	</mat-card>
</div>
